import ky from 'ky';

// Get API URL from environment variables and add /api prefix
const API_URL = `${import.meta.env.VITE_API_URL}/api`;

// Create configured Ky instance with defaults
export const api = ky.create({
  prefixUrl: API_URL,
  timeout: 30000,
  retry: 0, // Disabled - React Query will handle retries
  hooks: {
    beforeRequest: [
      request => {
        request.headers.set('X-Requested-With', 'XMLHttpRequest');
        
        // Add development logging
        if (import.meta.env.DEV) {
          console.log(`[API Request] ${request.method} ${request.url}`);
        }
      }
    ],
    afterResponse: [
      (_request, _options, response) => {
        // Log responses in development
        if (import.meta.env.DEV) {
          console.log(`[API Response] ${response.status} ${response.url}`);
        }
        return response;
      }
    ],
    beforeError: [
      error => {
        // Log errors in development
        if (import.meta.env.DEV) {
          console.error('[API Error]', error);
        }
        return error;
      }
    ]
  }
});

// Extended timeout client for screenshot operations
export const screenshotApiClient = api.extend({
  timeout: 60000 // 60 seconds for screenshot capture
});